"use client";

import { useEffect, type RefObject } from "react";
import { hidePublicHeader } from "@/components/public-header";

const SETTLE_MS = 400;

/* Arriving at the map from below is an upward scroll, which reveals the header over the map. */
export function useHideHeaderOnMapSnap(ref: RefObject<HTMLElement | null>, enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    let timer: ReturnType<typeof setTimeout> | undefined;
    const onScroll = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const top = ref.current?.getBoundingClientRect().top;
        if (top !== undefined && Math.abs(top) < 1) hidePublicHeader();
      }, SETTLE_MS);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
    };
  }, [ref, enabled]);
}
